import React, {useEffect, useState} from 'react';
import {
    CustomAntCheckbox,
    SettingsName,
    SPSettingsValue,
    TickerItemDiv
} from "../CPSettingsBlock/cPSettingsBlockStyles";
import {UnderlinedInput} from "components/Inputs/inputsStyles";
import {BasedSelect} from "components/Selects/BasedSelect";
import {GreenSelectArrow} from "assets/images";
import {BasedOption} from "components/Selects/selectStyles";

function SpItem({name,
    isInput = false,
    isCheckbox = false,
    isDropdown = false,
    currentValue,
    onInputChange,
    has_change
}: any) {
    const [valueBase] = useState(currentValue)
    const [isChanged, setIsChange] = useState(false)

    const middlewareInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onInputChange(e.currentTarget.value);
    }

    useEffect(() => {
        const _has_change = has_change ? has_change : false;
        setIsChange(_has_change);
    }, [has_change]);

    return (
        <TickerItemDiv>
            <SettingsName>
                {name}
            </SettingsName>
            <SPSettingsValue>
                {isInput && <UnderlinedInput
                    isChanged={isChanged}
                    type="text" placeholder="Начните ввод"
                    value = { currentValue }
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => middlewareInputChange(e)}
                />}
                {isCheckbox && <CustomAntCheckbox type="checkbox"/>}
                {isDropdown && <BasedSelect
                    size="small"
                    suffixIcon={<GreenSelectArrow/>}
                    style={{backgroundColor: "green"}}
                >
                    <BasedOption value="rare">value 1</BasedOption>
                    <BasedOption value="gods">value 2</BasedOption>

                </BasedSelect>}
            </SPSettingsValue>
        </TickerItemDiv>
    );
}

export default SpItem;
